import * as types from './SettingsBaseTypes';

export default function SettingsBaseReducer(state, action) {
    const { type, payload } = action;

    switch (type) {
        case types.GET_SETTINGS_BASE:
            return {
                ...state,
                getSettingsBase: {
                    ...state.getSettingsBase,
                    settingsBase: payload.data,
                    id: payload.id,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    },
                },
            };
        case types.GET_SETTINGS_BASE_LOADING:
            return {
                ...state,
                getSettingsBase: {
                    ...state.getSettingsBase,
                    loading: true
                },
            };
        case types.GET_SETTINGS_BASE_ERROR:
            return {
                ...state,
                getSettingsBase: {
                    ...state.getSettingsBase,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    },
                },
            };
        case types.UPDATE_SETTINGS_BASE:
            return {
                ...state,
                updateSettingsBase: {
                    ...state.updateSettingsBase,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    },
                }
            };
        case types.UPDATE_SETTINGS_BASE_LOADING:
            return {
                ...state,
                updateSettingsBase: {
                    ...state.updateSettingsBase,
                    loading: true
                }
            };
        case types.UPDATE_SETTINGS_BASE_ERROR:
            return {
                ...state,
                updateSettingsBase: {
                    ...state.updateSettingsBase,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    },
                }
            };
        case types.UPDATE_SETTINGS_BASE_RESET_STATE:
            return {
                ...state,
                updateSettingsBase: {
                    ...state.updateSettingsBase,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    },
                }
            };
        case types.GET_COUNTRIES:
            return {
                ...state,
                getCountries: {
                    ...state.getCountries,
                    countries: payload.data,
                    firstCountry: payload.first,
                    lastCountry: payload.last,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    },
                },
            };
        case types.GET_COUNTRIES_LOADING:
            return {
                ...state,
                getCountries: {
                    ...state.getCountries,
                    loading: true
                },
            };
        case types.GET_COUNTRIES_ERROR:
            return {
                ...state,
                getCountries: {
                    ...state.getCountries,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    },
                },
            };
        case types.GET_COUNTRIES_BY_ID:
            return {
                ...state,
                getCountriesById: {
                    ...state.getCountriesById,
                    country: payload,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    },
                }
            };
        case types.GET_COUNTRIES_BY_ID_LOADING:
            return {
                ...state,
                getCountriesById: {
                    ...state.getCountriesById,
                    loading: true
                }
            };
        case types.GET_COUNTRIES_BY_ID_ERROR:
            return {
                ...state,
                getCountriesById: {
                    ...state.getCountriesById,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    },
                }
            };
        case types.CREATE_COUNTRIES:
            return {
                ...state,
                createCountries: {
                    ...state.createCountries,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    },
                }
            };
        case types.CREATE_COUNTRIES_LOADING:
            return {
                ...state,
                createCountries: {
                    ...state.createCountries,
                    loading: true
                }
            };
        case types.CREATE_COUNTRIES_ERROR:
            return {
                ...state,
                createCountries: {
                    ...state.createCountries,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    },
                }
            };
        case types.CREATE_COUNTRIES_RESET_STATE:
            return {
                ...state,
                createCountries: {
                    ...state.createCountries,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    },
                }
            };
        case types.UPDATE_COUNTRIES_BY_ID:
            return {
                ...state,
                updateCountriesById: {
                    ...state.updateCountriesById,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    },
                }
            };
        case types.UPDATE_COUNTRIES_BY_ID_LOADING:
            return {
                ...state,
                updateCountriesById: {
                    ...state.updateCountriesById,
                    loading: true
                }
            };
        case types.UPDATE_COUNTRIES_BY_ID_ERROR:
            return {
                ...state,
                updateCountriesById: {
                    ...state.updateCountriesById,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    },
                }
            };
        case types.GET_CURRENCIES:
            return {
                ...state,
                getCurrenciesByCountry: {
                    ...state.getCurrenciesByCountry,
                    currencies: payload.data,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    },
                },
            };
        case types.GET_CURRENCIES_LOADING:
            return {
                ...state,
                getCurrenciesByCountry: {
                    ...state.getCurrenciesByCountry,
                    loading: true
                },
            };
        case types.GET_CURRENCIES_ERROR:
            return {
                ...state,
                getCurrenciesByCountry: {
                    ...state.getCurrenciesByCountry,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    },
                },
            };
        case types.CREATE_CURRENCIES:
            return {
                ...state,
                createCurrenciesByCountry: {
                    ...state.createCurrenciesByCountry,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    },
                }
            };
        case types.CREATE_CURRENCIES_LOADING:
            return {
                ...state,
                createCurrenciesByCountry: {
                    ...state.createCurrenciesByCountry,
                    loading: true
                }
            };
        case types.CREATE_CURRENCIES_ERROR:
            return {
                ...state,
                createCurrenciesByCountry: {
                    ...state.createCurrenciesByCountry,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    },
                }
            };
        case types.UPDATE_CURRENCIES_BY_ID:
            return {
                ...state,
                updateCurrenciesById: {
                    ...state.updateCurrenciesById,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    },
                }
            };
        case types.UPDATE_CURRENCIES_BY_ID_LOADING:
            return {
                ...state,
                updateCurrenciesById: {
                    ...state.updateCurrenciesById,
                    loading: true
                }
            };
        case types.UPDATE_CURRENCIES_BY_ID_ERROR:
            return {
                ...state,
                updateCurrenciesById: {
                    ...state.updateCurrenciesById,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    },
                }
            };
        case types.GET_CITIES_BY_COUNTRY:
            return {
                ...state,
                getCitiesByCountry: {
                    ...state.getCitiesByCountry,
                    cities: payload,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null,
                    }
                }
            };
        case types.GET_CITIES_BY_COUNTRY_LOADING:
            return {
                ...state,
                getCitiesByCountry: {
                    ...state.getCitiesByCountry,
                    loading: true
                }
            };
        case types.GET_CITIES_BY_COUNTRY_ERROR:
            return {
                ...state,
                getCitiesByCountry: {
                    ...state.getCitiesByCountry,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    },
                }
            };
        case types.CREATE_CITIES_BY_COUNTRY:
            return {
                ...state,
                createCitiesByCountry: {
                    ...state.createCitiesByCountry,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    }
                }
            };
        case types.CREATE_CITIES_BY_COUNTRY_LOADING:
            return {
                ...state,
                createCitiesByCountry: {
                    ...state.createCitiesByCountry,
                    loading: true
                }
            };
        case types.CREATE_CITIES_BY_COUNTRY_ERROR:
            return {
                ...state,
                createCitiesByCountry: {
                    ...state.createCitiesByCountry,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                }
            };
        case types.UPDATE_CITIES_BY_COUNTRY:
            return {
                ...state,
                updateCitiesByCountry: {
                    ...state.updateCitiesByCountry,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    }
                }
            };
        case types.UPDATE_CITIES_BY_COUNTRY_LOADING:
            return {
                ...state,
                updateCitiesByCountry: {
                    ...state.updateCitiesByCountry,
                    loading: true
                }
            };
        case types.UPDATE_CITIES_BY_COUNTRY_ERROR:
            return {
                ...state,
                updateCitiesByCountry: {
                    ...state.updateCitiesByCountry,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                }
            };
        case types.UPDATE_COUNTRIES_RESET_STATE:
            return {
                ...state,
                updateCountriesById: {
                    ...state.updateCountriesById,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
                updateCurrenciesById: {
                    ...state.updateCurrenciesById,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
                updateCitiesByCountry: {
                    ...state.updateCitiesByCountry,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
    
        default:
            return state;
    }
}